import React, { FC } from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { Theme } from '@constants';
import { useContextReference } from '@hooks';

import { styles } from './styles';

import { FocusableHighlight, FocusableHighlightProps } from '../FocusableHighlight/FocusableHighlight';
import { TWCTileButtonContent } from '../TWCTileButtonContent/TWCTileButtonContent';

export const TWCTileButton: FC<TWCTileButtonProps> = ({
  active,
  accessibilityHint,
  accessibilityLabel,
  children,
  nativeID,
  testID,
  title,
  onPress,
  nextFocusDown,
  nextFocusLeft,
  nextFocusRight,
  nextFocusUp,
}) => (
  <FocusableHighlight
    accessibilityHint={accessibilityHint}
    accessibilityLabel={accessibilityLabel}
    nativeID={nativeID || testID}
    nextFocusDown={nextFocusDown}
    nextFocusLeft={nextFocusLeft}
    nextFocusRight={nextFocusRight}
    nextFocusUp={nextFocusUp}
    ref={useContextReference(testID)}
    style={[styles.button, !active && styles.inactive]}
    styleFocused={Theme.styles.border}
    testID={testID}
    underlayColor={Theme.rhinoGrey}
    onPress={onPress}
  >
    {active ? (
      <LinearGradient colors={[Theme.darkCeruleanBlue, Theme.pacificBlue]} style={styles.container}>
        <TWCTileButtonContent title={title}>{children}</TWCTileButtonContent>
      </LinearGradient>
    ) : (
      <View style={styles.container}>
        <TWCTileButtonContent title={title}>{children}</TWCTileButtonContent>
      </View>
    )}
  </FocusableHighlight>
);

type TWCTileButtonProps = FocusableHighlightProps & {
  active?: boolean;
  title?: string;
};
